import { gql } from '@apollo/client';

export const CREATE_USER_INTERVIEWS_PROJECT = gql`
  mutation CreateUserInterviewsProject($segmentId: ID!) {
    createUserInterviewsProject(segmentId: $segmentId) {
      segment {
        id
        userInterviewsProjectId
        userInterviewsProjectUrl
        userInterviewsProjectCreatedAt
        userInterviewsProjectLaunch
        userInterviewsProjectLaunchAt
      }
    }
  }
`;

export const LAUNCH_USER_INTERVIEWS_PROJECT = gql`
  mutation LaunchUserInterviewsProject($segmentId: ID!) {
    launchUserInterviewsProject(segmentId: $segmentId) {
      segment {
        id
        userInterviewsProjectId
        userInterviewsProjectUrl
        userInterviewsProjectCreatedAt
        userInterviewsProjectLaunch
        userInterviewsProjectLaunchAt
      }
    }
  }
`;
